import { useState, useCallback } from 'react';
import { Config, ConfigItem, NewItem } from '../types';
import { validateNewItem } from '../utils/jsonUtils';
import { DEFAULT_CONFIG, DEFAULT_NEW_ITEM, VALIDATION_MESSAGES } from '../utils/constants';

export const useConfigManager = () => {
    const [config, setConfig] = useState<Config>(DEFAULT_CONFIG);

    const [newItem, setNewItem] = useState<NewItem>(DEFAULT_NEW_ITEM);

    const addItem = useCallback(() => {
        if (!validateNewItem(newItem)) {
            alert('لطفا تمام فیلدها را پر کنید');
            return;
        }

        const item: ConfigItem = {
            id: Date.now(),
            ...newItem
        };

        setConfig(prev => ({
            ...prev,
            list: [...prev.list, item]
        }));

        setNewItem({ title: '', image: '', url: '' });
    }, [newItem]);

    const removeItem = useCallback((id: number) => {
        setConfig(prev => ({
            ...prev,
            list: prev.list.filter(item => item.id !== id)
        }));
    }, []);

    const updateItem = useCallback((id: number, field: keyof ConfigItem, value: string) => {
        setConfig(prev => ({
            ...prev,
            list: prev.list.map(item =>
                item.id === id ? { ...item, [field]: value } : item
            )
        }));
    }, []);

    const moveItemUp = useCallback((index: number) => {
        if (index === 0) return;
        setConfig(prev => {
            const newList = [...prev.list];
            [newList[index], newList[index - 1]] = [newList[index - 1], newList[index]];
            return { ...prev, list: newList };
        });
    }, []);

    const moveItemDown = useCallback((index: number) => {
        if (index === config.list.length - 1) return;
        setConfig(prev => {
            const newList = [...prev.list];
            [newList[index], newList[index + 1]] = [newList[index + 1], newList[index]];
            return { ...prev, list: newList };
        });
    }, [config.list.length]);

    const updateConfig = useCallback((updates: Partial<Config>) => {
        setConfig(prev => ({ ...prev, ...updates }));
    }, []);

    const resetNewItem = useCallback(() => {
        setNewItem({ title: '', image: '', url: '' });
    }, []);

    return {
        config,
        newItem,
        setNewItem,
        addItem,
        removeItem,
        updateItem,
        moveItemUp,
        moveItemDown,
        updateConfig,
        resetNewItem
    };
}; 